
import React, { useState, useEffect } from "react";
import '../../gutenberg.css';
import '../../App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
const Home = () => {

	const [data, setData] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
	const fetchPage = async () => {
		try {
			const response = await fetch('https://wp1.edukacija.online/backend/wp-json/wp/v2/pages/241');
			if (!response.ok) {
			throw new Error(`Došlo je do greške: ${response.status}`);
			}
			const json = await response.json();
			setData(json);
		} catch (err) {
			setError(err.message);
		}
		};

		fetchPage();
	}, []);


	if (error) return <p>Greška: {error}</p>;
	if (!data) return <p>Učitavanje...</p>;

	 var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return(
    <>
      <div dangerouslySetInnerHTML={{ __html: data.content.rendered }} />
      
    </>
  );
};

export default Home;